import React, { useContext, useEffect, useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import useDeviceDetect from "../isMobile";
import Heading from "../Heading";
import TextField from "../TextField";
import TextAreaField from "../TextAreaField";
import "./createSale.scss";
import { toast } from "react-toastify";
import { UseSalesContract } from "../../../ConnectivityAss/hooks";
import axios from "axios";
import { url } from "../../../utils";
import moment from "moment";
import { Box } from "@mui/system";
import { AppContext } from "../../../utils";
import CloseIcon from "@mui/icons-material/Close";
import { AppBar, Dialog, IconButton, Slide, Toolbar } from "@mui/material";
import Loading from "../../../loading";
import CheckboxRadio from "../CheckboxRadio";

const tabsData = [
  {
    label: "Token information",
    step: 1,
    disabled: true,
  },
  {
    label: "Sales information",
    step: 2,
    disabled: true,
  },
  {
    label: "Soft/Hard Cap ",
    step: 3,
    disabled: true,
  },

  {
    label: "Additional information",
    step: 4,
    disabled: true,
  },
];
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
export default function Updatesale({ findData, setopen, open }) {
  const { account, signer } = useContext(AppContext);
  const { isMobile } = useDeviceDetect();

  const [tabs, setTabs] = useState(tabsData);
  const [activeTab, setActiveTab] = useState(1);
  // TOKEN INFORMATION
  const [tokenAddress, setTokenAddress] = useState("");
  const [tokenSymbol, setTokenSymbol] = useState("");
  const [tokenDecimel, setTokenDecimel] = useState("");
  const [tokenName, settokenName] = useState("");
  //  SALES INFORMATION
  const [hardCap, sethardCap] = useState("");
  const [tokensOnSale, settokensOnSale] = useState("");
  const [softCap, setsoftCap] = useState("");
  const [priceOfTokenOnSales, setPriceOfTokenOnSales] = useState("");
  const [startTimeold, setstartTime] = useState(new Date().getTime());
  const [endTimeold, setendTime] = useState(new Date().getTime());
  // PANCAKE LISTING
  const [liquidityPercent, setliquidityPercent] = useState("70");
  const [pancakeListingPrice, setPancakeListingPrice] = useState("1000");
  // ERROR STATE
  const [loading, setloading] = useState(false);

  // Additional info
  const [logoLink, setlogoLink] = useState(
    "https://bscpad.com/images/gfx-e.png"
  );
  const [coverImage, setcoverImage] = useState(
    "https://storage.googleapis.com/polkastarter-production-assets/54tb6ki60chdr3lip392cduk66zl"
  );
  const [webLink, setwebLink] = useState("https://bscpad.com/images/gfx-e.png");
  const [githubLink, setgithubLink] = useState(
    "https://bscpad.com/images/gfx-e.png"
  );
  const [twitterLink, settwitterLink] = useState(
    "https://bscpad.com/images/gfx-e.png"
  );
  const [redditLink, setredditLink] = useState(
    "https://bscpad.com/images/gfx-e.png"
  );
  const [telegramLink, settelegramLink] = useState(
    "https://bscpad.com/images/gfx-e.png"
  );
  const [projectDescription, setprojectDescription] = useState(
    "https://bscpad.com/images/gfx-e.png"
  );
  const [updateyouwant, setupdateyouwant] = useState(
    "https://bscpad.com/images/gfx-e.png"
  );
  const [projectName, setprojectName] = useState("test");

  useEffect(() => {
    try {
      setTokenAddress(findData.tokenAddress);
      setTokenSymbol(findData.tokenSymbol);
      setTokenDecimel(findData.tokenDecimal);
      setPriceOfTokenOnSales(findData.presaleRate);
      setstartTime(moment.unix(findData.startTime).format().slice(0, -9));
      setendTime(moment.unix(findData.endTime).format().slice(0, -9));
      sethardCap(findData.hardcap);
      setsoftCap(findData.softcap);
      setprojectName(findData.projectName);
      setcoverImage(findData.coverImage);
      setwebLink(findData.webLink);
      setlogoLink(findData.logoLink);
      setgithubLink(findData.githubLink);
      settwitterLink(findData.twitterLink);
      setredditLink(findData.redditLink);
      settelegramLink(findData.telegramLink);
      setprojectDescription(findData.projectDescription);
      setupdateyouwant(findData.updateyouwant);
    } catch (error) {}
  }, [open]);
  const submitHandler = async () => {
    let startTime = moment(startTimeold).format("X");
    let endTime = moment(endTimeold).format("X");
    if (!account) {
      toast.error("Error! Please connect your wallet ");
    } else {
      setloading(true);
      try {
        const fData = {
          tokenAddress,
          tokenName,
          tokenSymbol,
          tokenDecimel,
          priceOfTokenOnSales,
          hardCap,
          softCap,
          logoLink,
          coverImage,
          webLink,
          githubLink,
          twitterLink,
          redditLink,
          telegramLink,
          projectDescription,
          updateyouwant,
          startTime,
          endTime,
          projectName,
          account,
        };
        const { data } = await axios.put(
          `${url}/presaleRouter/IOD/${findData._id}`,
          fData
        );
        if (data.success) {
          toast.success(data.message);
          setloading(false);
        } else {
          toast.error(data.message);
          setloading(false);
        }
      } catch (error) {
        if (error?.data?.message) {
          toast.error(error?.data?.message);
          setloading(false);
        } else {
          toast.error(error?.message);
          setloading(false);
        }
      }
    }
  };

  const switchTab = (step) => {
    setTabs(
      tabs.map((item) =>
        item.step === step ? { ...item, disabled: false } : item
      )
    );
    setActiveTab(step);
  };

  const clickBack = () => {
    if (activeTab === 1) return;
    switchTab(activeTab - 1);
  };
  const clickNext = () => {
    if (activeTab === 6) {
      return;
    } else if (activeTab === 1 && !tokenAddress) {
      toast.error("Error! Please enter token Adrress");
    } else if (activeTab === 2 && !priceOfTokenOnSales) {
      toast.error("Error! Please enter tokens and price of tokens on sale.");
    } else if (activeTab === 3 && !softCap && !hardCap) {
      toast.error("Error! Please enter valid values of Softcap and Hardcap.");
    } else {
      switchTab(activeTab + 1);
    }
  };

  const buttonHtml = (
    <div className="createSaleNext dFA jcSB">
      {activeTab > 1 ? (
        <span className="back cP" onClick={clickBack}>
          Back
        </span>
      ) : null}

      {activeTab === 1 ? (
        <span className="button cP" onClick={clickNext}>
          Next
        </span>
      ) : (
        <span
          className="button cP"
          onClick={() => (activeTab === 4 ? submitHandler() : clickNext())}
        >
          {activeTab === 4 ? "Submit" : "Next"}
        </span>
      )}
    </div>
  );
  const handleClose = () => {
    setopen(false);
  };
  return (
    <>
      <Loading loading={loading} />
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        style={{ backgroundColor: "#13062c", background: "#13062c" }}
      >
        <AppBar sx={{ position: "relative", background: "#13062c" }}>
          <Toolbar>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              width="100%"
            >
              <Box fontSize="20px">Edit Project Info</Box>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </Toolbar>
        </AppBar>
        <Box bgcolor="#13062c" pb={10}>
          <div className="container pdt50 createSale">
            <Heading className="saleHeading" headingText="Create sale" />
            <div className={`createSaleBox ${isMobile ? "" : "oH"}`}>
              <div className="tabs pR">
                <Tabs
                  className={`${!isMobile ? "dF" : ""}`}
                  selectedIndex={activeTab - 1}
                  onSelect={(index) => {
                    setActiveTab(index + 1);
                  }}
                >
                  <TabList className="leftSide w100">
                    {tabs.map((item, i) => {
                      const tabProps = {
                        disabled: item.disabled,
                        className: activeTab - 1 >= i ? "active" : "",
                      };

                      return (
                        <Tab key={i} {...tabProps}>
                          <div className="mSite">{item.label}</div>
                          <span>
                            <b>{item.step}</b>
                          </span>
                        </Tab>
                      );
                    })}
                  </TabList>
                  <div className="tabsPanels w100">
                    {/* Token information */}
                    <TabPanel>
                      <div className="createSaleFields">
                        <div className="fieldTextRow">
                          <TextField
                            type="text"
                            placeholder="Enter here"
                            label="Token address"
                            className="fieldText"
                            value={tokenAddress}
                            readOnly
                            onChange={(e) => {
                              setTokenAddress(e.target.value);
                            }}
                            maxLength={42}
                          />
                          <TextField
                            type="text"
                            placeholder="Enter here"
                            label="Token symbol"
                            className="fieldText"
                            value={tokenSymbol}
                            readOnly
                          />

                          <TextField
                            type="text"
                            placeholder="Enter here"
                            label="Token decimal"
                            className="fieldText"
                            value={tokenDecimel}
                            readOnly
                          />
                        </div>
                      </div>

                      {buttonHtml}
                    </TabPanel>
                    {/* Sales information limit */}
                    <TabPanel>
                      <div className="createSaleFields">
                        <div className={`${isMobile ? "" : "dF"}`}>
                          <div className="fieldTextRow">
                            {/* <TextField
                              type="text"
                              placeholder="Enter here"
                              label="Token for sale"
                              className="fieldText"
                              value={tokensOnSale}
                              onChange={(e) => settokensOnSale(e.target.value)}
                            /> */}
                            <TextField
                              type="text"
                              placeholder="Enter token here"
                              label="Tokens per BUSD"
                              className="fieldText"
                              value={priceOfTokenOnSales}
                              readOnly
                              onChange={(e) =>
                                setPriceOfTokenOnSales(e.target.value)
                              }
                            />
                          </div>
                          <div className="fieldTextRow">
                            <TextField
                              type="datetime-local"
                              placeholder="Enter here"
                              label="Sale start"
                              className="fieldText"
                              value={startTimeold}
                              readOnly
                              onChange={(e) => {
                                setstartTime(e.target.value);
                              }}
                            />
                            <TextField
                              type="datetime-local"
                              placeholder="Enter here"
                              label="Sale end"
                              className="fieldText"
                              value={endTimeold}
                              readOnly
                              onChange={(e) => {
                                setendTime(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      {buttonHtml}
                    </TabPanel>
                    <TabPanel>
                      <div className="createSaleFields">
                        <div className="fieldTextRow">
                          <TextField
                            type="text"
                            placeholder="Enter BUSD"
                            label="Soft cap"
                            className="fieldText"
                            QuestionIcon
                            readOnly
                            value={softCap}
                            onChange={(e) => setsoftCap(e.target.value)}
                          />
                          <TextField
                            type="text"
                            placeholder="Enter BUSD"
                            label="Hard cap"
                            className="fieldText"
                            QuestionIcon
                            readOnly
                            value={hardCap}
                            onChange={(e) => sethardCap(e.target.value)}
                          />
                        </div>
                      </div>

                      {buttonHtml}
                    </TabPanel>
                    {/* Additional information */}
                    <TabPanel>
                      <div className="createSaleFields">
                        <div className={`${isMobile ? "" : "dF"}`}>
                          <div className="fieldTextRow">
                            <TextField
                              type="text"
                              placeholder="Enter here"
                              label="Project name"
                              className="fieldText"
                              QuestionIcon
                              value={projectName}
                              onChange={(e) => setprojectName(e.target.value)}
                            />
                            <TextField
                              type="text"
                              label="Medium link"
                              className="fieldText"
                              QuestionIcon
                              value={githubLink}
                              onChange={(e) => setgithubLink(e.target.value)}
                              placeholder="Ex. https://www.medium..."
                            />
                            <TextField
                              type="text"
                              label="Reddit link"
                              className="fieldText"
                              QuestionIcon
                              value={redditLink}
                              onChange={(e) => setredditLink(e.target.value)}
                              placeholder="Ex. https://www.Reddit..."
                            />
                          </div>
                          <div className="fieldTextRow">
                            <TextField
                              type="text"
                              label="Website link"
                              className="fieldText"
                              QuestionIcon
                              value={webLink}
                              onChange={(e) => setwebLink(e.target.value)}
                              placeholder="Ex. https://www.galaxypad"
                            />
                            <TextField
                              type="text"
                              label="Logo link"
                              className="fieldText"
                              QuestionIcon
                              value={logoLink}
                              onChange={(e) => setlogoLink(e.target.value)}
                              placeholder="Ex. https://www.galaxypad/logo.png"
                            />
                          </div>
                          <div className="fieldTextRow">
                            <TextField
                              type="text"
                              label="Telegram link"
                              className="fieldText"
                              QuestionIcon
                              value={telegramLink}
                              onChange={(e) => settelegramLink(e.target.value)}
                              placeholder="Ex. https://t.me..."
                            />
                            <TextField
                              type="text"
                              label="Twitter link"
                              className="fieldText"
                              QuestionIcon
                              value={twitterLink}
                              onChange={(e) => settwitterLink(e.target.value)}
                              placeholder="Ex. https://www.twitter..."
                            />
                            <TextField
                              type="text"
                              label="Cover Image"
                              className="fieldText"
                              QuestionIcon
                              value={coverImage}
                              onChange={(e) => setcoverImage(e.target.value)}
                              placeholder="https://storage.googleapis.com/polkastarter-production-assets/54tb6ki60chdr3lip392cduk66zl"
                            />
                          </div>
                        </div>
                        <div className="projectDescription">
                          <div className={`${isMobile ? "" : "dF"}`}>
                            <TextAreaField
                              type="textarea"
                              placeholder="https://bscpad.com/images/gfx-e.png"
                              label="Project description"
                              className="textAreas"
                              QuestionIcon
                              value={projectDescription}
                              onChange={(e) =>
                                setprojectDescription(e.target.value)
                              }
                            />
                            <div className="fieldTextRow wChange">
                              <TextField
                                type="text"
                                placeholder="Enter here"
                                label="Updates you want"
                                className="fieldText"
                                QuestionIcon
                                value={updateyouwant}
                                onChange={(e) =>
                                  setupdateyouwant(e.target.value)
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* <h1> tab 6 </h1> */}

                      {buttonHtml}
                    </TabPanel>
                  </div>
                </Tabs>
              </div>
            </div>
          </div>
        </Box>
      </Dialog>
    </>
  );
}
